import React, { Component } from 'react'
import PlanAlert from '../../../../ui/plans/PlanAlert'
import AccountSettingsForm from '../forms/AccountSettingsForm'

class AccountTab extends Component {
    render() {
        return (
            <div className="account-tab">
                <PlanAlert plan="gold" />
                <AccountSettingsForm />
            </div>
        )
    }
}

export default AccountTab